import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction, getAction } from '@/api/manage';
import moment from 'moment';
import WorkTasksDrawer from "./modules/WorkTasksDrawer";
export default {
  name: 'workCalendar',
  components: {
    WorkTasksDrawer: WorkTasksDrawer
  },
  mixins: [],
  data: function data() {
    return {
      loadding: false,
      showAddBtn: false,
      listData: [],
      pagePath: '/work/tasks/calendar/',
      findUrl: '/work/tasks/',
      type: 1,
      modeDate: ''
    };
  },
  created: function created() {
    this.type = 2;
    this.queryWorkPlan(new Date(), this.type);
  },
  watch: {
    '$store.state.bgLight': function $storeStateBgLight() {
      this.$forceUpdate();
    }
  },
  methods: {
    panelChange: function panelChange(value, mode) {
      if (mode == 'year') {
        this.type = 1;
      } else if (mode == 'month') {
        this.type = 2;
      }

      this.queryWorkPlan(value, this.type);
    },
    queryWorkPlan: function queryWorkPlan(value, type) {
      var _this = this;

      this.modeDate = this.value;
      var time;

      if (type == 1) {
        time = moment(value).format('YYYY');
      } else if (type == 2) {
        time = moment(value).format('YYYY-MM');
      }

      getAction(this.pagePath + time + '/' + type).then(function (res) {
        if (res.success) {
          _this.listData = res.result;
        }
      });
    },
    getListData: function getListData(value) {
      var res;
      value = moment(value).format('YYYY-MM-DD');
      res = this.listData.find(function (item) {
        return item.dateStr === value;
      });
      return res || {};
    },
    getMonthData: function getMonthData(value) {
      var res;
      value = moment(value).format('YYYY-MM');
      res = this.listData.find(function (item) {
        return item.dateStr === value;
      });
      return res || {};
    },
    showModal: function showModal() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    modalFormOk: function modalFormOk() {
      this.queryWorkPlan(this.modeDate, this.type);
    },
    selectItem: function selectItem(item) {
      var _this2 = this;

      getAction(this.findUrl + item).then(function (res) {
        if (res.success) {
          _this2.$refs.modalForm.disableSubmit = true;

          _this2.$refs.modalForm.edit(res.result);

          _this2.$refs.modalForm.title = '办理';
          _this2.$refs.modalForm.isOK = res.result.status == 1 ? true : false;
        } else {
          _this2.$message.info(res.message);
        }
      });
    }
  }
};